module.exports = __webpack_public_path__ + "img/bornutti13.cca4b390.jpg";